$body = $("body");
$(document).on({
    ajaxStart: function() { $body.addClass("loading");    },
    ajaxStop: function() { 
    	setTimeout(function() {
    	$body.removeClass("loading"); 
    	}, 500);
    	setTimeout(function(){
	       	$("div.alert").animate({
			    	opacity: 0, // animate slideUp
			    	marginRight: '-200px'
			  	}, 
			  	'slow', 'linear', function() {
			    	$(this).remove();
			});
	    }, 5000 ); 
    }    
});

/* Check got data existing or not else redirect homepage */
function checkDataToRedirectHome(){
	let check = false;
	var address = $('#checking_variables').attr('data-address');
	var order_type = $('#checking_variables').attr('data-order_type');
	var longitude = $('#checking_variables').attr('data-longitude');
	var latitude = $('#checking_variables').attr('data-latitude');
	var store_code = $('#checking_variables').attr('data-store_code');
	//var delivery_pickup_time = $('#checking_variables').attr('data-delivery_pickup_time');
	if( !address || !order_type || !longitude || !latitude || !store_code ){
		check = true; // change to true to redirect homepage.
	}
	return check;
}

function numberWithCommas(x) {
	return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

$(function (e) {
	if ($(".alert-success").data( "suggest" ) == "1") {
    	if ($(window).width() < 960) {
    		showModal('basket-modal');
    	}
    }
	/* close alert message after 5 second */
	setTimeout(function(){
      	$("div.alert").animate({
		    	opacity: 0, // animate slideUp
		    	marginRight: '-200px'
		  	}, 
		  	'slow', 'linear', function() {
		    	$(this).remove();
		});
    }, 5000 ); 

    /* activate tooltips */
    $('[data-bs-toggle="tooltip"]').tooltip();

	/* test add dummy cart ajax */
    $('.test-ajax').on('click', function() {
		var r_upgrade = {
			CHZ: {name:'CHEEZE', action: 'remove', price: 25},
			ONION: {name: 'ONION', action: 'add', price: 40}
		};
		var deal_items = [
			{
				sku: 'PZA',
				crust_code: 'PAN',
				size_code: 'PER',
				type: 'PIZZA',
				price: 300,
				qty: 1,
				upgrades: r_upgrade,
				total_price: 40
			}, 
			{
				sku: 'DRK',
				crust_code: '',
				size_code: 'MD',
				type: 'DRINK',
				price: 50,
				qty: 1,
				upgrades: '',
				total_price: 0
			}
		];
		var deal_data = {
			sku: 'DEAL1',
    		crust_code: '',
    		size_code: '',
    		type: 'PROMOTION',
    		price: 800,
    		items: deal_items
		};
		$.ajaxSetup({
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }
        });
        $.ajax({
        	type: 'POST',
        	url: '/cart/add-dummy-deal',
        	data: deal_data,
        	success: function(data) {
        		$.each(data, function(k, v){
        			console.log(k, v);
        		});
        	}
        });
	});

	/* change language */
    $('body').on('click', '#change_locale_btn', function(e){
        var csrf_token = $('meta[name="csrf-token"]').attr('content'); // Get csrf token
        var lang = $(this).data('locate');
        $.post('/locale/' + lang, {'_token': csrf_token}, function(result) {
            window.location.reload();
        }, "json")
        .fail(function(jqXHR, textStatus, errorThrown) {
            $("#main_content").append('<div class="alert alert-danger">' + jqXHR.responseJSON.meta.message + '</div>');
        });
    });

    /* change hide/show password */
	$('body').on('click', '.input-password-wrap i', function(e){
		var input_hidden_status = $(this).data('hidden');
		if( input_hidden_status != true ){
			$(".input-password-wrap input").attr('type', 'password');
			$(this).data('hidden', true );
			$(this).removeClass('phc-visibility-off');
			$(this).addClass('phc-visibility');
		}else{
			$(".input-password-wrap input").attr('type', 'text');
			$(this).data('hidden', false );
			$(this).removeClass('phc-visibility');
			$(this).addClass('phc-visibility-off');
		}
	});

	$('.carousel-nutrition').each(function() {
		var total = $(this).find('.carousel-item').length;
		var currentIndex = $(this).find('.carousel-item.active').index() + 1;
		$(this).find('.slide-text').html(currentIndex + ' / '  + total);

		// This triggers after each slide change
		$(this).on('slid.bs.carousel', function () {
			currentIndex = $(this).find('.carousel-item.active').index() + 1;
			$(this).find('.slide-text').html(currentIndex + ' / ' + total);
		});
	});
	
	function ajaxPostcodeStoreSearch(search_string, order_type) {
        if (search_string.length > 2) {
            $.post('/get-stores-by-search', {
                store_location: search_string,
                order_type: order_type,
                _token: $('meta[name="csrf-token"]').attr('content')
            }).done(function(data) {
                var options = '<option value="">-</option>';
                $.each(JSON.parse(data.data), function(key, value){
                    options += '<option value="'+value.store_code+'" data-address="'+value.store_address+'" data-postcode="'+value.postcode+'">'+value.store_name+'</option>';
                });
                $('select#store').html(options);
                $('select#store').removeAttr('disabled');
            }).fail(function(jqXHR, textStatus, errorThrown) {
                $('select#store').removeAttr('disabled');
            });
        } 
    }
	$('body').on('click', '.postcode-search', function(e) {
        e.preventDefault();
        search_string = $('#address_search').val();
        order_type = $('#order_type').val();
        ajaxPostcodeStoreSearch(search_string, order_type);
    });	
    $('body').on('change', '#store', function(e) {
        e.preventDefault();
        postcode = $(this).find(':selected').attr('data-postcode');
        address = $(this).find(':selected').attr('data-address');
       	$('#postcode_text').val(postcode);
       	$('#postcode').val(postcode);
       	$('#address_text').val(address);
       	$('#address').val(address);
    });
});